export const getHasFrame = (items: any) => {
  return (
    items.filter((item) => item.sku.indexOf('FWHT') > -1).length > 0 ||
    items.filter((item) => item.sku.indexOf('FBLK') > -1).length > 0
  );
};
